import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseDialogComponent } from './dialog.component';

const routes: Routes = [{ path: '', component: BaseDialogComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DialogRoutingModule { }
